import { $el, $elParent } from 'src/scripts/utils/utils'
import { BaseComponent } from '../../components/base-component'

const BANNER_POSTER_SELECTOR = '[data-video-banner-poster]'

export class VideoBanner extends BaseComponent {
  isControlsEnabled: boolean
  isAutoplayEnabled: boolean

  constructor() {
    super()
    this.isControlsEnabled = this.hasAttribute('data-enable-controls')
    this.isAutoplayEnabled = this.hasAttribute('data-enable-autoplay')
  }

  mountComponent(): void {
    if (this.isAutoplayEnabled) {
      this.loadContent()
    }
    this.addListener(this, 'click', this.handleClick)
  }

  handleClick = (event: MouseEvent): void => {
    const video = $elParent('video', event.target)
    const poster = $elParent(BANNER_POSTER_SELECTOR, event.target)

    if (video) {
      const video = event.target as HTMLVideoElement

      if (!this.isControlsEnabled && video) {
        if (video.paused) {
          video.play()
        } else {
          video.pause()
        }
      }
    }

    if (poster) {
      this.loadContent()
    }
  }

  loadContent(): void {
    if (!this.getAttribute('loaded')) {
      this.addVideo()
      this.setAttribute('loaded', 'true')
    }
  }

  removeVideo(): void {
    const video = $el('video,  iframe', this)

    if (video) {
      video.remove()
      this.removeAttribute('loaded')
    }
  }

  addVideo(): void {
    const content = document.createElement('div')
    const template: HTMLTemplateElement = $el(
      '[data-video-banner-media-template]',
      this,
    )
    const templateContent = template?.content
    const container = $el('[data-video-banner-container]', this)

    if (!templateContent || !templateContent.firstElementChild) {
      return
    }

    const firstChild = templateContent.firstElementChild.cloneNode(true)

    content.appendChild(firstChild)

    const video: HTMLVideoElement = $el('video, iframe', content)
    if (!video) {
      return
    }

    const poster = $el(BANNER_POSTER_SELECTOR, this)

    if (poster) {
      poster.remove()
    }

    container.appendChild(video)

    if (video.tagName === 'VIDEO') {
      video.play()
    }
  }
}
